import React from 'react';
import ProgressiveImage from "react-progressive-image";
import assets from "../../../util/assets";
import Zoom from "react-medium-image-zoom";
import "./index.css";
import loading_blue from "../../../assets/gif/loading_blue.gif";
import PropTypes from "prop-types";

FollowingItem.propTypes = {
    index: PropTypes.number.isRequired,
    broadcaster_id: PropTypes.string.isRequired,
    profile_pic: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    followers_count: PropTypes.number.isRequired,
    is_following: PropTypes.bool.isRequired,
};

function FollowingItem(props) {
    const isFollowing = props.is_following;
    const isSameAsCurrentUser = props.currentUserData.username === props.username;

    return (
        <div className="display-flex-justify-content-space-between all-followers-individual-item">
            <div className="display-flex-align-center">
                <ProgressiveImage
                    delay={1000}
                    src={props.profile_pic}
                    placeholder="placeholder">
                    {(src, loading) => {
                        return loading ? (
                                <img alt="profile picture"
                                     width="72"
                                     className="all-followers-user-profile-pic"
                                     src={assets.user_placeholder}/>
                            ) :
                            (
                                <div style={{position:'relative'}}>
                                    <Zoom>
                                        <img width="72"
                                             className="all-followers-user-profile-pic"
                                             alt={"profile picture"}
                                             src={props.profile_pic}/>
                                    </Zoom>
                                    <img
                                        className="all-followers-broadcaster-profile-pic-status"
                                        src={props.is_verified === 1 ? assets.clipstore.home.broadcaster_verified : assets.clipstore.home.broadcaster_unverified}
                                        alt="verified broadcaster"/>
                                </div>
                            )

                    }}
                </ProgressiveImage>
                <div className="all-followers-text-container">
                    <div className="all-followers-username">{props.username}</div>
                    <div className="all-followers-username-followers">{props.followers_count} Followers</div>
                </div>
            </div>

            <div className="display-flex-align-center">
                <button type="button"
                        className="btn btn-outline-primary"
                        disabled={isSameAsCurrentUser}
                        onClick={() => {
                            props.clickedOnChat(props.broadcaster_id)
                        }}>
                    <div>
                        <img src={assets.messaging.chat_icon_inactive} alt={"chat"}
                             className="user-profile-btn-img"/>
                        <span>CHAT</span>
                    </div>
                </button>

                <button type="button"
                        className="btn btn-outline-primary"
                        disabled={isSameAsCurrentUser}
                        onClick={() => {
                            props.clickedOnFollowUnfollow(props.index)
                        }}>
                    {
                        props.following.isFetching
                            ?
                            <img src={loading_blue} alt={"Loading"} width={26} height={26}/>
                            :
                            <div>
                                <img
                                    src={isFollowing ? assets.clipstore.home.more.more_unfollow : assets.clipstore.home.more.more_follow}
                                    alt={"chat"}
                                    className="user-profile-btn-img"/>
                                <span>{isFollowing ? "UNFOLLOW" : "FOLLOW"}</span>
                            </div>
                    }
                </button>
            </div>


        </div>
    );
}

export default FollowingItem;